import { maxSpacingValue as C, minSpacingValue as I } from "../../theme/spacing.js";
import { isBetweenInclusive as _ } from "../isBetweenInclusive/index.js";
import '../../assets/index7.css';const t = {
  "m-0": "aICb2a_m-0",
  "m-1": "aICb2a_m-1",
  "m-10": "aICb2a_m-10",
  "m-2": "aICb2a_m-2",
  "m-3": "aICb2a_m-3",
  "m-4": "aICb2a_m-4",
  "m-5": "aICb2a_m-5",
  "m-6": "aICb2a_m-6",
  "m-7": "aICb2a_m-7",
  "m-8": "aICb2a_m-8",
  "m-9": "aICb2a_m-9",
  "mb-0": "aICb2a_mb-0",
  "mb-1": "aICb2a_mb-1",
  "mb-10": "aICb2a_mb-10",
  "mb-2": "aICb2a_mb-2",
  "mb-3": "aICb2a_mb-3",
  "mb-4": "aICb2a_mb-4",
  "mb-5": "aICb2a_mb-5",
  "mb-6": "aICb2a_mb-6",
  "mb-7": "aICb2a_mb-7",
  "mb-8": "aICb2a_mb-8",
  "mb-9": "aICb2a_mb-9",
  "ml-0": "aICb2a_ml-0",
  "ml-1": "aICb2a_ml-1",
  "ml-10": "aICb2a_ml-10",
  "ml-2": "aICb2a_ml-2",
  "ml-3": "aICb2a_ml-3",
  "ml-4": "aICb2a_ml-4",
  "ml-5": "aICb2a_ml-5",
  "ml-6": "aICb2a_ml-6",
  "ml-7": "aICb2a_ml-7",
  "ml-8": "aICb2a_ml-8",
  "ml-9": "aICb2a_ml-9",
  "mr-0": "aICb2a_mr-0",
  "mr-1": "aICb2a_mr-1",
  "mr-10": "aICb2a_mr-10",
  "mr-2": "aICb2a_mr-2",
  "mr-3": "aICb2a_mr-3",
  "mr-4": "aICb2a_mr-4",
  "mr-5": "aICb2a_mr-5",
  "mr-6": "aICb2a_mr-6",
  "mr-7": "aICb2a_mr-7",
  "mr-8": "aICb2a_mr-8",
  "mr-9": "aICb2a_mr-9",
  "mt-0": "aICb2a_mt-0",
  "mt-1": "aICb2a_mt-1",
  "mt-10": "aICb2a_mt-10",
  "mt-2": "aICb2a_mt-2",
  "mt-3": "aICb2a_mt-3",
  "mt-4": "aICb2a_mt-4",
  "mt-5": "aICb2a_mt-5",
  "mt-6": "aICb2a_mt-6",
  "mt-7": "aICb2a_mt-7",
  "mt-8": "aICb2a_mt-8",
  "mt-9": "aICb2a_mt-9",
  "p-0": "aICb2a_p-0",
  "p-1": "aICb2a_p-1",
  "p-10": "aICb2a_p-10",
  "p-2": "aICb2a_p-2",
  "p-3": "aICb2a_p-3",
  "p-4": "aICb2a_p-4",
  "p-5": "aICb2a_p-5",
  "p-6": "aICb2a_p-6",
  "p-7": "aICb2a_p-7",
  "p-8": "aICb2a_p-8",
  "p-9": "aICb2a_p-9",
  "pb-0": "aICb2a_pb-0",
  "pb-1": "aICb2a_pb-1",
  "pb-10": "aICb2a_pb-10",
  "pb-2": "aICb2a_pb-2",
  "pb-3": "aICb2a_pb-3",
  "pb-4": "aICb2a_pb-4",
  "pb-5": "aICb2a_pb-5",
  "pb-6": "aICb2a_pb-6",
  "pb-7": "aICb2a_pb-7",
  "pb-8": "aICb2a_pb-8",
  "pb-9": "aICb2a_pb-9",
  "pl-0": "aICb2a_pl-0",
  "pl-1": "aICb2a_pl-1",
  "pl-10": "aICb2a_pl-10",
  "pl-2": "aICb2a_pl-2",
  "pl-3": "aICb2a_pl-3",
  "pl-4": "aICb2a_pl-4",
  "pl-5": "aICb2a_pl-5",
  "pl-6": "aICb2a_pl-6",
  "pl-7": "aICb2a_pl-7",
  "pl-8": "aICb2a_pl-8",
  "pl-9": "aICb2a_pl-9",
  "pr-0": "aICb2a_pr-0",
  "pr-1": "aICb2a_pr-1",
  "pr-10": "aICb2a_pr-10",
  "pr-2": "aICb2a_pr-2",
  "pr-3": "aICb2a_pr-3",
  "pr-4": "aICb2a_pr-4",
  "pr-5": "aICb2a_pr-5",
  "pr-6": "aICb2a_pr-6",
  "pr-7": "aICb2a_pr-7",
  "pr-8": "aICb2a_pr-8",
  "pr-9": "aICb2a_pr-9",
  "pt-0": "aICb2a_pt-0",
  "pt-1": "aICb2a_pt-1",
  "pt-10": "aICb2a_pt-10",
  "pt-2": "aICb2a_pt-2",
  "pt-3": "aICb2a_pt-3",
  "pt-4": "aICb2a_pt-4",
  "pt-5": "aICb2a_pt-5",
  "pt-6": "aICb2a_pt-6",
  "pt-7": "aICb2a_pt-7",
  "pt-8": "aICb2a_pt-8",
  "pt-9": "aICb2a_pt-9"
};
function n(a, b = {}) {
  if (a)
    for (const m in b) {
      const p = b[m];
      _(p, I, C) && (a[t[`${m}-${p}`]] = !0);
    }
}
export {
  n as injectSpacingClasses
};
//# sourceMappingURL=index.js.map
